var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"data-loader"}),(_vm.data.length == 0 && !_vm.loading)?_c('list-status',{attrs:{"size":_vm.size,"title":"暂无数据~"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }